export default "__VITE_ASSET__CtKKXPTQ__"